import axios from "axios";

const { SERVICES_URL } = window.MLBBest.envVariables || {};

const ClipsClient = axios.create({ baseURL: SERVICES_URL });

export default ClipsClient;
